<template>
  <div
    class="inbox--name custom-color inline-flex items-center py-0.5 px-0 leading-3 font-medium bg-none text-slate-600 dark:text-slate-500 text-xs my-0 mx-2.5 max-w-32 overflow-hidden"
  >
    <fluent-icon
      class="mr-0.5 rtl:ml-0.5 rtl:mr-0 flex-shrink-0"
      :icon="computedInboxClass"
      viewBox="0 0 27 24"
      size="15"
    />
    <span class="truncate">{{ inbox.name }}</span>
  </div>
</template>
<script>
import { getInboxClassByType } from 'dashboard/helper/inbox';

export default {
  props: {
    inbox: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    computedInboxClass() {
      const { phone_number: phoneNumber, channel_type: type } = this.inbox;
      const classByType = getInboxClassByType(type, phoneNumber);
      return classByType;
    },
  },
};
</script>
<style scoped>
.custom-color {
  color: #BEBEBE;
}
</style>